export default __webpack_public_path__ + "static/media/outlook.51e5a155.svg";